/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, inject } from '@angular/core';
import { leerContextoDeProducto } from './contexto-producto.storage';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TokenBridgeService {
  readonly cookieService = inject(CookieService);

  public tokens$ = new Subject<any>();

  public setToken(token: string): void {
    localStorage.setItem('access_token', token);
  }

  public saveToCookie(): void {
    const cookieData = {
      accessToken: localStorage.getItem('access_token'),
      refreshToken: localStorage.getItem('refresh_token') || '',
      userData: localStorage.getItem('user_data') || null,
      tokenExpiry: localStorage.getItem('token_expiry') || null,
      hasMultipleModules: localStorage.getItem('hasMultipleModules') || 'false',
      selectedProductId: leerContextoDeProducto('selectedProductId') || null,
      selectedRoute: leerContextoDeProducto('selectedRoute') || null,
      selectedModule: leerContextoDeProducto('selectedModule') || null,
      timestamp: Date.now(),
    };

    this.cookieService.delete('app_data', '/');

    const expires = 1;
    const path = '/';
    const domain = undefined;
    const secure = false;
    const sameSite: 'Lax' | 'Strict' | 'None' = 'Lax';

    this.cookieService.set(
      'app_data',
      JSON.stringify(cookieData),
      expires,
      path,
      domain,
      secure,
      sameSite,
    );

    this.cookieService.set('app_data', JSON.stringify(cookieData), expires, path);
  }

  public updateCookie(): void {
    this.saveToCookie();
  }

  public getTokenCookie(): any {
    const cookieValue = this.cookieService.get('app_data');
    if (cookieValue) {
      return JSON.parse(cookieValue);
    }

    return null;
  }

  public removeCookie(key: string): void {
    this.cookieService.delete(key, '/');
  }

  public sendTokens(): void {
    const cookieData = this.getTokenCookie();
    if (cookieData) {
      this.tokens$.next({
        type: 'TOKENS_RESPONSE',
        tokens: cookieData,
      });
    }
  }

  public getCurrentTokens(): any {
    return {
      accessToken: localStorage.getItem('access_token'),
      refreshToken: localStorage.getItem('refresh_token') || '',
      userData: localStorage.getItem('user_data') || null,
      tokenExpiry: localStorage.getItem('token_expiry') || null,
      hasMultipleModules: localStorage.getItem('hasMultipleModules') || 'false',
      selectedProductId: leerContextoDeProducto('selectedProductId') || null,
      selectedRoute: leerContextoDeProducto('selectedRoute') || null,
      selectedModule: leerContextoDeProducto('selectedModule') || null,
      timestamp: Date.now(),
    };
  }

  public checkCookieStatus(): boolean {
    const exists = this.cookieService.check('app_data');
    return exists;
  }

  public setHasMultipleModules(value: boolean): void {
    localStorage.setItem('hasMultipleModules', value.toString());
    sessionStorage.setItem('hasMultipleModules', value.toString());
    this.updateCookie();
  }

  public getHasMultipleModules(): boolean {
    const cookieData = this.getTokenCookie();
    if (cookieData && cookieData.hasMultipleModules) {
      return cookieData.hasMultipleModules === 'true';
    }
    return localStorage.getItem('hasMultipleModules') === 'true';
  }

  public getTokenExpiry(): number | null {
    const cookieData = this.getTokenCookie();
    if (cookieData && cookieData.tokenExpiry) {
      return parseInt(cookieData.tokenExpiry, 10);
    }
    const expiry = localStorage.getItem('token_expiry');
    return expiry ? parseInt(expiry, 10) : null;
  }

  public isTokenValid(): boolean {
    const expiry = this.getTokenExpiry();
    if (!expiry) return false;
    return Date.now() < expiry - 30000;
  }
}
